export class CreditInvoiceItem {

  public description: string;
  public amount: number;
  public price: string;
}
